(function(){const R=[
[/^travelite$/i,'all/travelite'],
[/^air\s+base$/i,'all/air-base'],
[/\b(stockschirm|straight umbrella|ombrello a bastone)\b/i,'regenschirme'],
[/\b(taschenschirm|folding umbrella|ombrello pieghevole)\b/i,'regenschirme'],
[/\b(regenschirm|schirm|umbrella|ombrell[io])\b/i,'schirme'],
[/\b(sporttasche|gym bag|borsa sportiva)\b/i,'taschen-rucksacke'],
[/\b(rucksack|rucksaecke|backpacks?|zain[io])\b/i,'taschen-rucksacke'],
[/\b(tasche|taschen|bags?|bors[ae]|shopper)\b/i,'taschen-rucksacke'],
[/\b(thermoflasche|thermosflasche|thermal bottle|bottiglia termica)\b/i,'premium-thermoflaschen'],
[/\b(trinkflasche|flasche|becher|bottles?|cups?|borracci[ae]|tazza)\b/i,'trinkflaschen-becher'],
[/\b(arbeitsbekleidung|arbeitskleidung|workwear|work clothing|abbigliamento da lavoro|work)\b/i,'arbeitskleidung'],
[/\b(warnweste|sicherheitsweste|hi vis vest|gilet alta visibilita)\b/i,'warnwesten-sicherheitswesten'],
[/\b(warnschutz|high visibility|alta visibilita)\b/i,'warnschutz-zubehor'],
[/\b(softshell)\b/i,'softshell'],[/\b(fleece|pile)\b/i,'fleece'],
[/\b(hoodies?|kapuzenpullover|felpa con cappuccio)\b/i,'sweatshirts-hoodies'],
[/\b(sweatshirts?|felpe?|felpa)\b/i,'sweatshirts-hoodies'],
[/\b(poloshirts?|polo)\b/i,'poloshirts'],[/\b(t-?shirts?|magliett[ae])\b/i,'t-shirts'],
[/\b(hemd|hemden|bluse|blusen|camici[ae])\b/i,'hemden-blusen'],
[/\b(jacke|jacken|jackets?|giacc[ae])\b/i,'jacken'],
[/\b(weste|westen|strick|vest|gilet|maglia)\b/i,'westen-strick'],
[/\b(hose|hosen|rock|roecke|trousers|pants|pantaloni|gonna)\b/i,'hosen-rocke'],
[/\b(schuerze|kasack|apron|grembiule|casacca)\b/i,'schurzen-kasacks'],
[/\b(sportbekleidung|sportswear|abbigliamento sportivo|fussball|football|calcio)\b/i,'sportbekleidung'],
[/\b(outdoor|freizeit|leisure|tempo libero)\b/i,'freizeit-outdoor'],
[/\b(schuh|schuhe|clogs?|shoes?|scarp[ae]|zoccoli)\b/i,'schuhe-clogs'],
[/\b(trucker caps?)\b/i,'snapback-caps-kopie'],[/\b(snapback|flat caps?)\b/i,'flat-caps'],
[/\b(military caps?)\b/i,'military-caps'],[/\b(kids caps?|kinder cap|cappellino bambino)\b/i,'kids-caps'],
[/\b(beanies?|muetze|wintermuetze|berretto)\b/i,'beanie'],[/\b(caps?|kappe|kappen|cappellin[io])\b/i,'baseball-caps'],
[/\b(handtuch|handtuecher|towels?|asciugamano)\b/i,'handtucher'],
[/\b(unterwaesche|socken|underwear|socks|biancheria|calze)\b/i,'unterwasche-socken'],
[/\b(stirnband|headband|fascia)\b/i,'stirnband'],[/\b(schal|handschuh|scarf|gloves|sciarpa|guanti)\b/i,'schals-handschuhe'],
[/\b(koffer|suitcase|valigia)\b/i,'koffer'],[/\b(trolley)\b/i,'trolley'],[/\b(reiseartikel|travel|viaggio)\b/i,'reiseartikel'],
[/\b(werbeartikel|werbemittel|giveaways?|promotional item|articolo promozionale|gadgets?)\b/i,'werbeartikel-gadgets'],
[/\b(nachhaltig|sustainable|sostenibile)\b/i,'nachhaltige-werbeartikel'],
[/\b(kugelschreiber|pens?|penn[ae])\b/i,'kugelschreiber'],[/\b(notizbuch|notizbuecher|notebooks?|taccuino)\b/i,'buero-notizbuecher'],
[/\b(schluesselanhaenger|keyring|portachiavi)\b/i,'schluesselanhaenger'],[/\b(technik|elektronik|electronics|elettronica)\b/i,'technik-elektronik'],
[/\b(haushalt|kueche|household|kitchen|casa|cucina)\b/i,'haushalt-kueche'],[/\b(spielzeug|pluesch|toys?|peluche)\b/i,'spielzeug-pluesch'],
[/\b(vereinsbekleidung|club clothing|abbigliamento associazione)\b/i,'vereinsbekleidung'],[/\b(feuerwehr|fire brigade|vigili del fuoco)\b/i,'feuerwehr']];
const N=v=>(v||'').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss');
const AIR_BASE=[
['075341','Air Base Trolley S Slim'],
['075345','Air Base Trolley S erweiterbar'],
['075346','Air Base Trolley S+'],
['075347','Air Base Trolley S'],
['075348','Air Base Trolley M erweiterbar'],
['075349','Air Base Trolley L'],
['air_base_set','Air Base Kofferset']];
const root=()=>((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/').replace(/\/$/,'');
const curated=q=>q==='travelite'?{path:'all/travelite',label:'Alle Travelite-Produkte anzeigen',items:[]}:q==='air base'?{path:'all/air-base',label:'Alle Air-Base-Produkte anzeigen',items:AIR_BASE}:null;
function tunePredictiveSearch(){
  document.querySelectorAll('predictive-search').forEach(box=>{
    const input=box.querySelector('input[name="q"],input[type="search"]');
    const query=N(input&&input.value);
    const rule=curated(query);
    box.querySelectorAll('[data-la1970-curated-search]').forEach(node=>{if(!rule||node.dataset.la1970CuratedSearch!==query)node.remove()});
    if(!rule){box.querySelectorAll('#predictive-search-results-products-list > li').forEach(li=>li.hidden=false);return;}
    const list=box.querySelector('#predictive-search-results-products-list');
    if(list){
      const allowed=rule.items.map(([handle])=>'/products/la1970-travelite-'+handle);
      list.querySelectorAll('li').forEach(li=>{
        const href=(li.querySelector('a[href*="/products/"]')||{}).href||'';
        li.hidden=rule.items.length?!allowed.some(path=>href.includes(path)):!href.includes('/products/la1970-travelite-');
      });
      rule.items.forEach(([handle,label])=>{
        const path='/products/la1970-travelite-'+handle;
        if([...list.querySelectorAll('a')].some(a=>(a.getAttribute('href')||'').includes(path)))return;
        const li=document.createElement('li');
        li.className='predictive-search__list-item';
        li.dataset.la1970CuratedSearch=query;
        li.setAttribute('role','option');
        li.innerHTML='<a class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1" href="'+root()+path+'"><div class="predictive-search__item-content predictive-search__item-content--centered"><p class="predictive-search__item-heading h5">Travelite '+label+'</p></div></a>';
        list.appendChild(li);
      });
    }
    const button=box.querySelector('[data-predictive-search-search-for-text]');
    if(button)button.textContent=rule.label;
  });
}
document.addEventListener('submit',e=>{const f=e.target;if(!(f instanceof HTMLFormElement)||!(f.action||'').includes('/search'))return;const i=f.querySelector('input[name="q"],input[type="search"]');if(!i)return;const q=N(i.value),r=R.find(x=>x[0].test(q));if(!r)return;e.preventDefault();e.stopImmediatePropagation();location.assign(root()+'/collections/'+r[1])},true);
document.addEventListener('input',e=>{if(e.target.matches&&e.target.matches('input[name="q"],input[type="search"]'))setTimeout(tunePredictiveSearch,350)},true);
new MutationObserver(tunePredictiveSearch).observe(document.documentElement,{childList:true,subtree:true});
})();
